import React, { Component } from "react";
import { connect } from "react-redux";

//MUI
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class UserLogs extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography>user logs</Typography>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UserLogs));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/log_tabs/UserLogs.js